import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import axiosInstance from '../../axiosInstance';

import { useBlogContext } from '../../fetchdata/BlogContext';

const Contact = () => {


  const { Headers, isHeader, cartItems, AllProducts, AllCategoriess } = useBlogContext();


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await axiosInstance.post('/contact-enquire', formData);
      toast.success('Email sent successfully');
      setFormData({ name: '', email: '', message: '' }); // Clear form fields
    } catch (error) {
      console.error('Failed to send email:', error);
      toast.error('Failed to send email');
    }
  };

  return (
    <>
      <Header />


      <section className="contact-section py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="contact-card shadow-lg rounded-4 overflow-hidden">
                <div className="row g-0">

                  {/* LEFT INFO */}
                  <div className="col-md-5 bg-light p-4 text-dark border-right">
                    <h4 className="fw-bold mb-3">Get in Touch</h4>
                    <p className="small mb-4 ">
                      We’d love to hear from you. Fill out the form and our team will get back to you shortly.
                    </p>

                    {!isHeader && (
                      <>
                        <div className="contact-info-item">
                          <i className="fas fa-phone-alt"></i>
                          <span>+91 {Headers.phone}</span>
                        </div>

                        <div className="contact-info-item">
                          <i className="fas fa-envelope"></i>
                          <span>{Headers.email}</span>
                        </div>

                        <div className="contact-info-item">
                          <i className="fas fa-map-marker-alt"></i>
                          <span>{Headers.address}</span>
                        </div>
                      </>
                    )}

                    <div className="social-icons mt-4">
                      <a href="#"><i className="fab fa-facebook-f"></i></a>
                      <a href="#"><i className="fab fa-instagram"></i></a>
                      <a href="#"><i className="fab fa-twitter"></i></a>
                    </div>
                  </div>

                  {/* RIGHT FORM */}
                  <div className="col-md-7 p-4">
                    <h4 className="fw-bold mb-3">Contact Us</h4>

                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control custom-input"
                          placeholder="Your Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <input
                          type="email"
                          className="form-control custom-input"
                          placeholder="Email Address"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <input
                          type="tel"
                          className="form-control custom-input"
                          placeholder="Phone Number"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <textarea
                          className="form-control custom-input"
                          placeholder="Your Message"
                          rows="4"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        ></textarea>
                      </div>

                      <button className="btn btn-dark w-100 py-2 fw-semibold">
                        Send Message
                      </button>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <Footer />

    </>

  )
}

export default Contact